if ( typeof ProductPage !== 'function' ) {

	class ProductPage extends HTMLElement {
		constructor(){

			super();

			this.productGallery = this.querySelector('[data-js-product-gallery]');
			this.productSlider = this.querySelector('css-slider');

			this.pickupAvailabilityExtended = this.querySelector('pickup-availability-extended');

			// Gallery thumbnails
			if ( this.productSlider ) {

				const productGaleryThumbnails = this.querySelector('.product-gallery__thumbnails-holder');

				if ( this.querySelector('.product-gallery__thumbnails .thumbnail') ) {

					this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
						if ( i == 0 )  {
							elm.classList.add('active');
						}
						elm.addEventListener('click',e=>{
							if ( this.productSlider.sliderEnabled ) {
								this.productSlider.changeSlide(e.currentTarget.dataset.index);
							} else {
								window.scrollTo({
									top: this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`).getBoundingClientRect().top + window.scrollY,
									behavior: 'smooth'
								});
								this.thumbnailNavigationHelper(e.currentTarget.dataset.index);
							}
							this._pauseAllMedia();
							this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.currentTarget.dataset.index}"]`));
							productGaleryThumbnails.scrollTo({
								left: elm.offsetLeft - 50,
								behaviour: 'smooth'
							})
						});
					})

					this.productSlider.addEventListener('change', e=>{
						this.thumbnailNavigationHelper(e.target.index);
					});

				}

				this.productSlider.addEventListener('navigation', e=>{
					this._playMedia(this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`));
				})
				this.productSlider.addEventListener('change', e=>{
					const productBadge = document.querySelector('.product-badge');

					if (productBadge) {
						if (e.target.index == 0) {
							productBadge.classList.remove('hidden');
						} else {
							productBadge.classList.add('hidden');
						}
					}
					this._pauseAllMedia();
					if ( this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.productMediaType == 'model' ) {
						if ( this.xrButton ) {
							this.xrButton.setAttribute('data-shopify-model3d-id', this.productGallery.querySelector(`.product-gallery-item[data-index="${e.target.index}"]`).dataset.mediaId);
						}
						setTimeout(()=>{
							this.productSlider.querySelector('.css-slider-holder').classList.add('css-slider--disable-dragging');
						}, 150);
					}
				});

				// Parallax

				this.productSlider.addEventListener('ready', (e)=>{
					if ( this.firstProductGalleryIndex ) {
						this.productSlider.changeSlide(this.firstProductGalleryIndex, "auto");
					}
				});

				let savePercent = this.querySelector('.product__subscription-save-percent');
				if (savePercent) {
					let saveFlag = 0, _this = this;
					setInterval(function(){
						if (saveFlag) {
							savePercent.classList.add('show-percent');
							saveFlag = 0;
						} else {
							savePercent.classList.remove('show-percent');
							saveFlag = 1;
						}
					}, 3000);
				}

			}

			// Product variant event listener for theme specific logic

			this.productVariants = this.querySelector('product-variants[data-main-product-variants]');
			if ( this.productVariants ) {
				this.productVariants.addEventListener('VARIANT_CHANGE', this.onVariantChangeHandler.bind(this));
				this.onVariantChangeHandler({target:this.productVariants});

				// refresh color
				this.querySelectorAll('.product-variant__item--radio').forEach(elm=>{
					elm.addEventListener('click', e=>{
						if ( elm.classList.contains('product-variant__item--color' ) ) {
							elm.closest('.product-variant').querySelector('.product-variant__item-text-label').textContent = elm.querySelector('input').value;
						}
					})
				});

			}

			const supplementFactModal = document.querySelector('.supplement-facts-modal');

			if(supplementFactModal) {
				const btnList = supplementFactModal.querySelectorAll('.supplement-facts-modal-header__btn');

				btnList.forEach(btn => {
					btn.addEventListener('click', () => {
						const type = btn.dataset.type;

						if(!type) {
							return;
						}

						const activeContent = supplementFactModal.querySelector('.supplement-facts-modal__content--show');
						const activeBtn = supplementFactModal.querySelector('.supplement-facts-modal-header__btn--active');

						if(activeContent) {
							activeContent.classList.remove('supplement-facts-modal__content--show');
						}

						if(activeBtn) {
							activeBtn.classList.remove('supplement-facts-modal-header__btn--active')
						}

						const newActiveContent = supplementFactModal.querySelector(`.supplement-facts-modal__content[data-type="${type}"]`);

						if(newActiveContent) {
							newActiveContent.classList.add('supplement-facts-modal__content--show');
						}

						btn.classList.add('supplement-facts-modal-header__btn--active');
					});
				});

				const closeBtn = supplementFactModal.querySelector('.supplement-facts-modal__close');

				if (closeBtn) {
					closeBtn.addEventListener('click', () => {
						supplementFactModal.classList.remove('supplement-facts-modal--show');
					});
				}

				const openBtn = document.querySelector('.js-open-supplement-modal');

				if(openBtn) {
					openBtn.addEventListener('click', (e) => {
						e.preventDefault();
						supplementFactModal.classList.add('supplement-facts-modal--show');
					});
				}

				const modalWrap = document.querySelector('.supplement-facts-modal__wrap');
				
				if(modalWrap) {
					supplementFactModal.addEventListener('click', e => {
						if (!modalWrap.contains(e.target)) {
							supplementFactModal.classList.remove('supplement-facts-modal--show');
						}
					});
				}
			}

			const rtx_container = this.querySelector('.rtx_container');
			const productCart = this.querySelector('.js-product-cart');

			if (rtx_container) {
				const productPage = rtx_container.closest('product-page');
				if (productPage) {
					const buttonText = productPage.querySelector('.js-button-text');
					const subscribeBarButtonText = productPage.querySelector('.product__bar-offer .add-to-cart .button__text') || productPage.querySelector('.subscribe-bar .add-to-cart .button__text');
					const subscribeBarButtonTextSource = productPage.querySelector('.product__bar-offer [data-plan-button-texts]');
					const subscribeBarButtonCopies = {
						subscribe: subscribeBarButtonTextSource?.dataset.subscribeButtonText,
						onetime: subscribeBarButtonTextSource?.dataset.onetimeButtonText
					};
					const setSubscribeBarButtonCopy = (planType) => {
						if (!subscribeBarButtonText) {
							return;
						}
						const copy = planType === 'onetime'
							? (subscribeBarButtonCopies.onetime || 'Try It Risk Free!')
							: (subscribeBarButtonCopies.subscribe || 'Subscribe Now');
						subscribeBarButtonText.textContent = copy;
					};
					const setSubscribeBarState = (planType) => {
						setSubscribeBarButtonCopy(planType);
					};
					const description = productPage.querySelector('.product__subscription-description');
					const subscriptionOption = rtx_container.querySelector('.rtx_option.rtx_option--sub');
					const subscribeOptionIconsWithTexts = productPage.querySelector('.subscribe-option_icons_with_texts')
					const onetimeOptionIconsWithTexts = productPage.querySelector('.onetime-option_icons_with_texts')
					const servingPriceOld = productPage.dataset.servingPriceOld;
					const servingPriceNew = productPage.dataset.servingPriceNew;
					const priceNew = productPage.dataset.priceNew;
					const priceOld = productPage.dataset.priceOld;
					const productId = productPage.dataset.id;

					let selling_plan, product__delivery_select = this.querySelector('.product__delivery-select');
					const savePercent = document.querySelector('.product__subscription-save-percent');

					if(savePercent) {
						savePercent.addEventListener('click', e=>{
							productPage.querySelector('.rtx_option.rtx_option--sub .rtx_option_label').click();
						});
					}

					if (subscriptionOption) {
						const selector = subscriptionOption.querySelector('.rtx_option_selector');
						if (selector) {
							description && selector.after(description);
							document.querySelector('.product-actions--secondary') && savePercent && selector.after(savePercent);
						}
					}

					if(document.querySelector('.form--custom')) {
						savePercent.style.display = 'none';
					}

					if(product__delivery_select) {
						let product__delivery_selectHTML = '';
						let optionPlanValue = '';
						this.querySelectorAll('.rtx_option_plans_dropdown option').forEach(elm=>{
							const text = elm.text.replace('Ships every', '');
							let selected = '';
							let cls = '';
							if (text.indexOf('4 Week') != -1) {
								selected = ' selected';
								cls = ' product-cart-item--active';
								optionPlanValue = elm.value;
							}
							product__delivery_selectHTML += `<option${selected} value="${elm.value}">${text}</option>`;
						});
						product__delivery_select.innerHTML = product__delivery_selectHTML;
						this.querySelector('.rtx_option_plans_dropdown').value = optionPlanValue;

						let rtx_option_plans_dropdown = this.querySelector('.rtx_option_plans_dropdown');
						product__delivery_select.addEventListener('change', function( event ) {
							rtx_option_plans_dropdown.value = event.currentTarget.value;
							rtx_option_plans_dropdown.dispatchEvent(new Event('change'))
						});
					}

					document.querySelectorAll('.rtx_option .rtx_option_selector').forEach(elm=>{
						let selling_plan_select = elm.querySelector('[name="selling_plan_select"]');
						selling_plan = selling_plan_select.value;
						if (selling_plan_select.checked) {
							if (selling_plan == 'onetime') {
								document.body.classList.add('subscription-option-onetime');
								setSubscribeBarState('onetime');
								//onetimeOptionIconsWithTexts.classList.add('show');
								//buttonText.innerHTML = 'Try Risk Free!';
							} else {
								document.body.classList.add('subscription-option-subsave');
								setSubscribeBarState('subscribe');
								//buttonText.innerHTML = 'Subscribe & Save';
							}
						}

						const subHeadingBlock = elm.querySelector('.rtx_option_subheading');
						let subHeadingHtml = '';

						if (selling_plan == 'onetime') {
							if(!priceOld) {
								return;
							}

							subHeadingHtml = priceOld;
							if(servingPriceOld && servingPriceOld !== '$0.00') {
								subHeadingHtml += `<div class="product__onetime-serving-price">${servingPriceOld} per serving</div>`
							}
						} else {
							if(!priceOld || !priceNew) {
								return;
							}
							subHeadingHtml =`${priceNew}<span class="product__subsave-old-price">${priceOld}</span>`;
						}

						subHeadingBlock.innerHTML = subHeadingHtml;

						let rtx_option = elm.closest('.rtx_option');
						rtx_option.addEventListener('click', e=>{
							if (e.target.classList.contains('product__benefits-more-link')/* || e.target.classList.contains('product__delivery-select')*/) {

							} else {
								selling_plan = e.currentTarget.querySelector('[name="selling_plan_select"]').value;
								document.body.classList.remove('subscription-option-subsave');
								document.body.classList.remove('subscription-option-onetime');

								const priceBlock = productPage.querySelector('.product-regular-price');
								const servingPriceBlock = productPage.querySelector('.product-serving-price');
								const productPricesBlock = productPage.querySelector('.product-info');
								const changeCartBlock = (plan) => {
									if(!productCart) {
										return;
									}

									if(plan === 'one-time') {
										productCart.classList.add('product-cart--one-time');
									} else {
										productCart.classList.remove('product-cart--one-time');
									}

									const activeItemCart = productCart.querySelector('.product-cart-item--active');

									if(activeItemCart) {
										activeItemCart.classList.remove('product-cart-item--active');
									}

									const newActiveItemCart = productCart.querySelector(`.product-cart-item--${plan}`);

									if(newActiveItemCart) {
										newActiveItemCart.classList.add('product-cart-item--active');
									}
								}

								if (selling_plan == 'onetime') {
									document.body.classList.add('subscription-option-onetime');
									subscribeOptionIconsWithTexts.classList.remove('show');
									onetimeOptionIconsWithTexts.classList.add('show');

									if(buttonText) {
										buttonText.innerHTML = 'Try It Risk Free!';
									}
									setSubscribeBarState('onetime');

									if(priceBlock && priceOld) {
										priceBlock.innerText = priceOld;
									}

									if(servingPriceBlock && servingPriceOld) {
										servingPriceBlock.innerText = servingPriceOld;
									}

									if(productPricesBlock) {
										productPricesBlock.classList.remove('product-info--subscribe');
									}

									changeCartBlock('one-time');
								} else {
									document.body.classList.add('subscription-option-subsave');
									subscribeOptionIconsWithTexts.classList.add('show');
									onetimeOptionIconsWithTexts.classList.remove('show');

									if(buttonText) {
										buttonText.innerHTML = 'Subscribe Now';
									}
									setSubscribeBarState('subscribe');

									if(priceBlock && priceNew) {
										priceBlock.innerText = priceNew;
									}

									if(servingPriceBlock && servingPriceNew) {
										servingPriceBlock.innerText = servingPriceNew;
									}

									if(productPricesBlock) {
										productPricesBlock.classList.add('product-info--subscribe');
									}

									changeCartBlock('sub-save');
								}
								e.currentTarget.querySelector('[name="selling_plan_select"]').click();
								if (selling_plan !== 'onetime') {
									subHeadingBlock.innerHTML = subHeadingHtml;
								}
							}
						});
						if (selling_plan != 'onetime') {
							setTimeout(function(){
								elm.click();
								productPage.querySelector('.product__subscription-save-percent')?.classList.add('show');
								subscribeOptionIconsWithTexts.classList.add('show');
								elm.closest('.rtxn-block').classList.add('show');
							}, 1000);
						}
					});
					// see more benefits
					document.querySelectorAll('.subscribe_gotit').forEach(elm=>{
						elm.addEventListener('click', e=>{
							document.querySelectorAll('.subscribe_save_popup').forEach(elm1=>{
								elm1.style.display="none";
							});
						})
					});
					document.querySelectorAll('.close_btn').forEach(elm=>{
						elm.addEventListener('click', e=>{
							document.querySelectorAll('.subscribe_save_popup').forEach(elm1=>{
								elm1.style.display="none";
							});
						})
					});
					document.querySelectorAll('.product__benefits-more-link, .subscription-option__benefits-more-link').forEach(elm=>{
						elm.addEventListener('click', e=>{
							document.querySelectorAll('.subscribe_save_popup').forEach(elm1=>{
								elm1.style.display="flex";
							});
						})
					});

					const productCountBlock = productPage.querySelector('.product-variant__quantity');

					if(productCountBlock && productId) {
						const MAX_LIMIT_COUNT_PRODUCT = 7000;
						const MIN_LIMIT_COUNT_PRODUCT = 2500;
						const day = new Date().getDate();
						const pseudoProductQuantity = parseInt(productId[productId.length-5] + productId[productId.length-1] + productId[productId.length-3]);
						let countProduct = pseudoProductQuantity * 10;

						if(countProduct > MAX_LIMIT_COUNT_PRODUCT) {
							countProduct = countProduct - (countProduct - MAX_LIMIT_COUNT_PRODUCT) - pseudoProductQuantity;
						}

						if(countProduct < MIN_LIMIT_COUNT_PRODUCT) {
							countProduct = countProduct + (MIN_LIMIT_COUNT_PRODUCT - countProduct) + pseudoProductQuantity;
						}

						countProduct = countProduct - (day * 15); // 15 - daily sales

						productCountBlock.innerText = countProduct + ' Units Left';
					}

				}
			}

			// Add styles for the recharge subscription widget
			let buttonText, productPage, productPlan = null;
			const rechargeSubscriptionWidget = document.getElementsByTagName('recharge-subscription-widget')[0];
			if (rechargeSubscriptionWidget) {
				productPage = rechargeSubscriptionWidget.closest('product-page');
				buttonText = productPage.querySelector('.js-button-text');
				productPlan = document.getElementById('product-plan');
			}

			if(productPlan) {
				const init = (widgetRoot) => {
					// Add events
					widgetRoot.querySelectorAll('.rc-purchase-option__input').forEach(option=>{
						const sellingPlan = option.value;
						if (option.checked) {
							if (sellingPlan === 'onetime') {
								document.body.classList.add('subscription-option-onetime');
								buttonText.innerHTML = 'Try Risk Free!';
							} else {
								document.body.classList.add('subscription-option-subsave');
								buttonText.innerHTML = 'Subscribe & Save';
							}
						}
						option.addEventListener('click', e=>{
							const sellingPlan = option.value;
							if (sellingPlan === 'onetime') {
								document.body.classList.add('subscription-option-onetime');
								buttonText.innerHTML = 'Try Risk Free!';
							} else {
								document.body.classList.add('subscription-option-subsave');
								buttonText.innerHTML = 'Subscribe & Save';
							}
						});
					});

					const subscribeBlock = productPlan.querySelector('.product-plan__subscribe');

					if(subscribeBlock) {
						const createButtons = (plansBtnGroup) => {
							const planButtons = plansBtnGroup.querySelectorAll('label');
							const fragment = document.createDocumentFragment();
							const oldPrice = parseFloat(productPage.dataset.priceOld.match(/[\d.]+/)[0]);

							const handleClickSellingPlan = (event) => {
								const el = event.currentTarget;
								const currentPlan = el.dataset.plan || 'onetime';
								const inputPlan = widgetRoot.querySelector(`.rc-purchase-option__input[value="${currentPlan}"]`);

								if(!inputPlan) {
									return;
								}

								inputPlan.click();

								if(currentPlan === 'subscription') {
									const value = el.dataset.value;
									const input = plansBtnGroup.querySelector(`input[name="rc_plan"][value="${value}"]`);

									if(input) {
										input.click();
									}
								}

								const planBlocks = productPlan.querySelectorAll('.product-plan__item');
								planBlocks.forEach(plan => plan.classList.remove('product-plan__item--checked'));
								el.classList.add('product-plan__item--checked');
							};

							planButtons.forEach(btn => {
								const input = btn.querySelector('input');
								const intervalEl = btn.querySelector('.rc-plans-button__interval');
								const discountEl = btn.querySelector('.rc-plans-button__discount');

								if(input && intervalEl && discountEl) {
									const intervalValue = parseInt(intervalEl.innerText.replace(/\D/g, ""), 10) ?? 1;
									const discountPercent = parseInt(discountEl.innerText.replace(/\D/g, ""), 10) ?? 0;
									const discountValue = (oldPrice * discountPercent / 100).toFixed(2);
									const price = (oldPrice - discountValue).toFixed(2);

									const parentEl = this.createElement({
										cls: ['product-plan__item', input.checked ? 'product-plan__item--checked' : '' ],
										attrs: {
											role: 'button',
											'data-plan': 'subscription',
											'data-value': input.value,
										}
									});

									parentEl.addEventListener('click', handleClickSellingPlan);
									const bodyEl = this.createElement({ cls: ['product-plan__item-body'] });
									const firstRowEl = this.createElement({ cls: ['product-plan__item-col'] });
									const secondRowEl = this.createElement({ cls: ['product-plan__item-col', 'product-plan__item-col--prices'] });
									const priceEl = this.createElement({ cls: ['product-plan__item-price'] });
									priceEl.append(
										this.createElement({
											tag: 'span',
											cls: ['product-plan__item-price-value'],
											text: '$' + price,
										}),
										this.createElement({
											cls: ['product-plan__item-price-period'],
											text: '/mo',
											tag: 'span',
										})
									);
									firstRowEl.append(
										this.createElement({
											cls: ['product-plan__item-title'],
											text: intervalEl.innerText + ' Supply',
										}),
										this.createElement({
											cls: ['product-plan__item-text'],
											text: `$${price * intervalValue} every ${intervalValue} month`,
										})
									);
									secondRowEl.append(
										priceEl,
										this.createElement({
											cls: ['product-plan__item-discount'],
											text: discountEl.innerText,
										}),
									);

									bodyEl.append(firstRowEl, secondRowEl);
									parentEl.appendChild(bodyEl);
									fragment.appendChild(parentEl);
								}
							});
							subscribeBlock.appendChild(fragment);

							const onetimePlan = document.getElementById('onetime-plan');

							if(onetimePlan) {
								onetimePlan.addEventListener('click', handleClickSellingPlan)
							}
						}
						const sellingPlans = widgetRoot.getElementsByTagName('rc-selling-plans')[0];
						const plansBtnGroup = sellingPlans.shadowRoot.querySelector('.rc-plans-button-group');

						if(plansBtnGroup) {
							createButtons(plansBtnGroup);
						} else {
							this.waitForElementInShadowDOM(sellingPlans, '.rc-plans-button-group', createButtons);
						}
					}
				}
				const widget = rechargeSubscriptionWidget.shadowRoot.querySelector('.rc-widget__root');
				if(widget) {
					init(widget);
				} else {
					this.waitForElementInShadowDOM(rechargeSubscriptionWidget, '.rc-widget__root', init);
				}
			}

			const productShippingBlockText = this.querySelector('.product-variant__arrives_day strong, .product-shipping__date');

			if(productShippingBlockText) {
				const dateChicago = new Date(new Date().toLocaleString("en-US", {timeZone: "America/Chicago"}));
				const hours = dateChicago.getHours();
				const day = dateChicago.getDay();
				const optionsDate = {
					weekday: 'short',
					month: 'short',
					day: '2-digit'
				}

				if(day === 5 && hours >= 17) {
					dateChicago.setDate(dateChicago.getDate() + 3);
				} else if (day === 6) {
					dateChicago.setDate(dateChicago.getDate() + 2);
				} else if (day === 0 || hours >= 17) {
					dateChicago.setDate(dateChicago.getDate() + 1);
				}

				productShippingBlockText.innerText = dateChicago.toLocaleString('en-US', optionsDate);
			}

			// show cart drawer when element is added to cart

			if ( ! document.body.classList.contains('template-cart') && KROWN.settings.cart_action == 'overlay' ) {

				let addToCartEnter = false;
				if ( this.querySelector('[data-js-product-add-to-cart]') ) {
					this.querySelector('[data-js-product-add-to-cart]').addEventListener('keyup', e=>{
						if ( e.keyCode == window.KEYCODES.RETURN ) {
							addToCartEnter = true;
						}
					})
				}

				if ( this.querySelector('[data-js-product-form]') ) {
					this.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
						document.getElementById('site-cart-sidebar').show();
						if ( document.getElementById('cart-recommendations-sidebar') ) {
							document.getElementById('cart-recommendations-sidebar').generateRecommendations();
						}
						if ( addToCartEnter ) {
							setTimeout(()=>{
								document.querySelector('#site-cart-sidebar [data-js-close]').focus();
							}, 200);
						}
					});
				}

				const reviewsMainWidget = document.querySelector('#stamped-main-widget')
				if (reviewsMainWidget && !reviewsMainWidget?.dataset.productId) {
					reviewsMainWidget.setAttribute('data-product-id', this.dataset.id);
					window.StampedFn?.reloadUGC();
				}
			}

			// Check for models

			const models = this.querySelectorAll('product-model');
			if ( models.length > 0 ) {
				window.ProductModel.loadShopifyXR();
				this.xrButton = this.querySelector('.product-gallery__view-in-space');
			}

			// hide buy now button if stock disabled

			const addToCartButton = this.querySelector('[data-js-product-add-to-cart][data-main-product-add-to-cart]');
			if ( addToCartButton ) {
				if ( addToCartButton.classList.contains('disabled') ) {
					this.querySelector('product-form').classList.add('disable-buy-button');
				} else {
					this.querySelector('product-form').classList.remove('disable-buy-button');
				}
				const buyObserver = new MutationObserver(()=>{
					if ( addToCartButton.classList.contains('disabled') ) {
						this.querySelector('product-form').classList.add('disable-buy-button');
					} else {
						this.querySelector('product-form').classList.remove('disable-buy-button');
					}
				});
				buyObserver.observe(addToCartButton,{ attributes: true, childList: false, subtree: false });
			}

			// update secondary price if present

			this.priceCompact = this.querySelector('[data-js-product-price-compact]');
			this.priceExtended = this.querySelector('[data-js-product-price-extended]');

			if ( this.priceCompact ) {
				this.priceCompact.priceOriginal = this.priceCompact.querySelector('[data-js-product-price-original]');
				this.priceCompact.priceCompare = this.priceCompact.querySelector('[data-js-product-price-compare]');
				this.priceCompact.priceUnit = this.priceCompact.querySelector('[data-js-product-price-unit]');
			}
			if ( this.priceExtended ) {
				this.priceExtended.priceOriginal = this.priceExtended.querySelector('[data-js-product-price-original]');
				this.priceExtended.priceCompare = this.priceExtended.querySelector('[data-js-product-price-compare]');
				this.priceExtended.priceSaving = this.priceExtended.querySelector('[data-js-product-price-saving]');
				this.priceExtended.priceUnit = this.priceExtended.querySelector('[data-js-product-price-unit]');
			}

			if(productCart) {
				const productCartItemList = productCart.querySelectorAll('.js-product-cart-item');
				const productCartCustomBlock = productCart.querySelector('.js-product-cart-custom');
				const productCartQuantityInput = productCart.querySelector('.product-cart__quantity');
				const quantityDiscountBlock = productCart.querySelector('.product-cart-quantity__discount');
				const quantityCountBlock = productCart.querySelector('.product-cart-quantity__count');
				const quantityCostBlock = productCart.querySelector('.product-cart-quantity__cost');
				const quantityMinusBlock = productCart.querySelector('.product-cart-quantity__minus');
				const quantityPlusBlock = productCart.querySelector('.product-cart-quantity__plus');

				if(!productCartQuantityInput) {
					return;
				}

				function changeQuantityBlock(count) {
					const plan = document.getElementById('product_onetime').checked ? 'onetime' : 'subSave';
					const planData = frequencyData[plan];
					const planDataKeys = Object.keys(planData);
					let dataKey;

					if(planDataKeys.includes(count.toString())) {
						dataKey = count;
					} else {
						planDataKeys.forEach(key => {
							const numericKey = parseInt(key);

							if(count > numericKey) {
								dataKey = numericKey;
							}
						})
					}

					const data = frequencyData[plan][dataKey];

					if(data) {
						if(quantityDiscountBlock) {
							if(data.percent) {
								quantityDiscountBlock.innerText = data.percent + '% OFF';
								quantityDiscountBlock.style.display = 'block';
							} else {
								quantityDiscountBlock.style.display = 'none';
							}
						}


						if(data.cost && quantityCostBlock) {
							quantityCostBlock.innerText = `Only ${data.cost} per serving`;
						}
					}

					if(quantityCountBlock) {
						quantityCountBlock.innerText = count + (count === '1' ? ' Bag' : ' Bags');
					}

					productCartQuantityInput.value = count;
				}

				productCartItemList.forEach(item => {
					item.addEventListener('click', e => {
						e.preventDefault();
						const count = item.dataset.count;

						if(!count) {
							return;
						}

						const activeItem = productCart.querySelector('.product-cart-item--active');

						if(activeItem) {
							activeItem.classList.remove('product-cart-item--active');
						}

						item.classList.add('product-cart-item--active');

						productCartQuantityInput.value = count;
					});
				});

				if(productCartCustomBlock) {
					productCartCustomBlock.addEventListener('click', e => {
						e.preventDefault();
						productCart.classList.add('product-cart--custom-count');

						const activeItem = productCart.querySelector('.product-cart-item--active');

						if(!activeItem) {
							return;
						}

						const count = activeItem.dataset.count;

						if(!count) {
							return;
						}

						changeQuantityBlock(count);
					});
				}

				if(quantityMinusBlock && quantityPlusBlock) {
					quantityMinusBlock.addEventListener('click', e => {
						e.preventDefault();
						const value = parseInt(productCartQuantityInput.value);

						if(!value) {
							return;
						}

						const newValue = value - 1;

						if(newValue >= 1) {
							changeQuantityBlock(newValue);
						}

						if(newValue <= 1) {
							quantityMinusBlock.classList.add('product-cart-quantity__btn--disabled');
						}
					})

					quantityPlusBlock.addEventListener('click', e => {
						e.preventDefault();
						const value = parseInt(productCartQuantityInput.value);

						if(!value) {
							return;
						}

						const newValue = value + 1;
						quantityMinusBlock.classList.remove('product-cart-quantity__btn--disabled');
						changeQuantityBlock(newValue);
					})
				}

				const sellingPlanList = this.querySelectorAll('[name="selling_plan_select"]');
				sellingPlanList.forEach(plan => {
					plan.addEventListener('change', () => {
						changeQuantityBlock(productCartQuantityInput.value);
					});
				});
			}

			this.purchaseBlockInit();
		}

		purchaseBlockInit() {
			const purchaseBlock = this.querySelector('.purchase');

			if(!purchaseBlock) {
				return;
			}

			const subscribeIcons = purchaseBlock.querySelector('.subscribe-option_icons_with_texts');
			const onetimeIcons = purchaseBlock.querySelector('.onetime-option_icons_with_texts');
			const purchaseOptions = purchaseBlock.querySelectorAll('.purchase-options__radio');
			const purchaseBtn = purchaseBlock.querySelector('.purchase__btn');

			if(!purchaseBtn) {
				return;
			}

			purchaseOptions.forEach(option => {
				option.addEventListener('change', e => {
					const isSubscribe = e.target.value === 'subscribe';
					subscribeIcons?.classList.toggle('show', isSubscribe);
					onetimeIcons?.classList.toggle('show', !isSubscribe);
					purchaseBtn.href = option.parentElement.dataset.href;
				});
			});
		}

		thumbnailNavigationHelper(index=0){
			this.querySelectorAll('.product-gallery__thumbnails .thumbnail').forEach((elm, i)=>{
				if ( i == index )
					elm.classList.add('active');
				else
					elm.classList.remove('active');
			});
		}

		onVariantChangeHandler(e){

			let variant = e.target.currentVariant;
			if ( variant ) {

				// image handling

				if ( variant.featured_media != null ) {
					let variantImg = this.productGallery.querySelector('.product-gallery-item[data-media-id="' + variant.featured_media.id + '"]');
					if ( variantImg ) {
						if ( this.productGallery.classList.contains('product-gallery--slider') || ( this.productGallery.classList.contains('product-gallery--scroll') && window.innerWidth < 1024 ) ) {
							if ( this.productGallery.querySelector('css-slider') && this.productGallery.querySelector('css-slider').sliderEnabled ) {
								this.productGallery.querySelector('css-slider').changeSlide(variantImg.dataset.index);
							} else {
								this.firstProductGalleryIndex = variantImg.dataset.index;
							}
						} else {
							window.scrollTo({
								top: variantImg.getBoundingClientRect().top + window.scrollY,
								behavior: 'smooth'
							});
						}
					}
				}

				// refresh pickup availability widgets

				if ( this.pickupAvailabilityExtended && this.pickupAvailabilityExtended.classList.contains('active') ) {
					this.querySelector('pickup-availability-extended').fetchAvailability(variant.id);
				}

			}

			// update prices (overwrites the framework)

			if ( this.priceCompact ) {
				if ( !variant ) {
					if ( ! ( this.productVariants.variantRequired && this.productVariants.noVariantSelectedYet ) ) {
						this.priceCompact.classList.add('hide');
						this.priceCompact.priceOriginal.innerHTML = '';
						this.priceCompact.priceCompare.innerHTML = '';
						this.priceCompact.priceUnit.innerHTML = '';
					}
				} else {
					this.priceCompact.classList.remove('hide');
					this.priceCompact.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
					if ( variant.compare_at_price > variant.price ) {
						this.priceCompact.priceCompare.innerHTML = this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format);
						//this.priceCompact.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span><span class="product-item__badge">-${Math.round(Math.abs((variant.price * 100 / variant.compare_at_price) - 100))}%</span>`;
					} else {
						this.priceCompact.priceCompare.innerHTML = '';
					}

					if ( variant.unit_price_measurement ) {
						this.priceCompact.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceCompact.priceUnit.innerHTML = '';
					}
				}
			}

			if ( this.priceExtended ) {
				if ( !variant ) {
					this.priceExtended.classList.add('hide');
					this.priceExtended.priceOriginal.innerHTML = '';
					this.priceExtended.priceCompare.innerHTML = '';
					this.priceExtended.priceUnit.innerHTML = '';
					this.priceExtended.priceSaving.innerHTML = '';
				} else {
					this.priceExtended.classList.remove('hide');
					this.priceExtended.priceOriginal.innerHTML = this.productVariants._formatMoney(variant.price, KROWN.settings.shop_money_format);
					if ( variant.compare_at_price > variant.price ) {
						this.priceExtended.priceCompare.innerHTML = `<span>${this.productVariants._formatMoney(variant.compare_at_price, KROWN.settings.shop_money_format)}</span>`;
						this.priceExtended.priceSaving.innerHTML = `<span>${KROWN.settings.locales.product_compare_price.replace('$SAVE_PRICE', this.productVariants._formatMoney(variant.compare_at_price - variant.price, KROWN.settings.shop_money_format))}</span>`;
					} else {
						this.priceExtended.priceCompare.innerHTML = '';
						this.priceExtended.priceSaving.innerHTML = '';
					}

					if ( variant.unit_price_measurement ) {
						this.priceExtended.priceUnit.innerHTML = `
							${this.productVariants._formatMoney(variant.unit_price, KROWN.settings.shop_money_format)} / 
							${( variant.unit_price_measurement.reference_value != 1 ? variant.unit_price_measurement.reference_value + ' ' : '' )}
							${variant.unit_price_measurement.reference_unit}
						`;
					} else {
						this.priceExtended.priceUnit.innerHTML = '';
					}
				}
			}

		}

		_pauseAllMedia(){

			document.querySelectorAll('.product-gallery .js-youtube').forEach(video => {
				video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
			});
			document.querySelectorAll('.product-gallery .js-vimeo').forEach(video => {
				video.contentWindow.postMessage('{"method":"pause"}', '*');
			});
			document.querySelectorAll('.product-gallery video').forEach(video => video.pause());
			document.querySelectorAll('.product-gallery product-model').forEach(model => {
				if ( model.modelViewerUI )
					model.modelViewerUI.pause()
			});
		}

		_playMedia(media){
			switch ( media.dataset.productMediaType ) {
				case 'video':
					if ( media.querySelector('video') ) {
						media.querySelector('video').play();
					}
					break;
				case 'external_video-youtube':
					if ( media.querySelector('.js-youtube') ) {
						media.querySelector('.js-youtube').contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
					}
					break;
				case 'external_video-vimeo':
					if ( media.querySelector('.js-vimeo') ) {
						media.querySelector('.js-vimeo').contentWindow.postMessage('{"method":"play"}', '*');
					}
					break;
			}
		}

		waitForElementInShadowDOM(hostElement, elementSelector, callback) {
			if (!hostElement || !hostElement.shadowRoot) {
				return;
			}

			const observer = new MutationObserver((mutationsList, observer) => {
				const element = hostElement.shadowRoot.querySelector(elementSelector);

				if (element) {
					observer.disconnect(); // Stop observing once the element is found
					callback(element); // Execute the callback with the found element
				}
			});
			// Start observing the shadow root
			observer.observe(hostElement.shadowRoot, { childList: true, subtree: true });
		}

		createElement({ tag = 'div', cls = [], text, attrs = {} } = {}) {
			const el = document.createElement(tag);
			el.classList.add(...cls);
			Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));

			if(text) {
				el.innerText = text;
			}

			return el;
		}



	}

	if ( typeof customElements.get('product-page') == 'undefined' ) {
		customElements.define('product-page', ProductPage);
	}

}
